import Sidebar from "./components/sidebar/Sidebar";
// import Topbar from "./components/topbar/Topbar";
import "./App.css";
import ModernPageWrapper from "./components/ModernPageWrapper";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import ProductColor from "./pages/productColor/ProductColor";
import ProductGallery from "./pages/productGallery/ProductGallery";
import NewProduct from "./pages/newProduct/NewProduct";
import WarrantyList from "./pages/warrantyList/WarrantyList";
import ReturnList from "./pages/warrantyList/ReturnList";
import StockList from "./pages/warrantyList/StockList";
import NewWarranty from "./pages/newWarranty/NewWarranty";
import NewAdmin from "./pages/newAdmin/NewAdmin";
import NewAffiliate from "./pages/newAffiliate/NewAffiliate";
import OrderList from "./pages/orderList/OrderList";
import AffiliateList from "./pages/affiliateList/AffiliateList";
import History from "./pages/history/History";
import DepositHistory from "./pages/history/DepositHistory";
import DepositList from "./pages/depositList/DepositList";
import EcommerceList from "./pages/ecommerceList/EcommerceList";
import SalesReport from "./pages/salesReport/SalesReport";
import Report from "./pages/report/Reporting";
import Login from "./pages/login/Login";
import Pos from "./pages/pos/pos";
import Outlet from "./pages/outlet/Outlet";
import { useSelector } from "react-redux";
import TransactionList from "./pages/transaction/TransactionList";
import ProductReport from "./pages/productReport/ProductReport";
import ProductStatus from "./pages/productStatus/ProductStatus";
import AffiliateReport from "./pages/affiliateReport/AffiliateReport";
import Checklist from "./pages/checkList/CheckList";
import Campaign from "./pages/campaignList/Campaign";
import Transfer from "./pages/transfer/Transfer";
import DeliveryOrder from "./pages/deliveryOrderList/DeliveryOrder";
import DeliveryOrderUpload from "./pages/deliveryOrderUpload/DeliveryOrderUpload";
import CompleteDepositList from "./pages/completeDepositList/CompleteDepositList";
import NewBrand from "./pages/newBrand/newBrand";
import Brand from "./pages/brand/Brand";
import NewCategory from "./pages/newCategory/newCategory";
import Category from "./pages/category/Category";
import TradeIn from "./pages/pos/tradein";
import TradeInList from "./pages/orderList/TradeIn";
import Journal from "./pages/pos/journal";
import Supplier from "./pages/pos/supplier";
import JournalList from "./pages/orderList/Journal";
import SupplierList from "./pages/orderList/Supplier";
import StatementList from "./pages/orderList/StatementList";
import EditOrder from "./pages/pos/editOrder";
import NewVehicle from "./pages/vehicle/vehicle";
import VehicleList from "./pages/vehicle/VehicleList";
import Assets from "./pages/pos/assets";
import NewSupplier from "./pages/newUser/NewSupplier";
import Journals from "./pages/history/Journal";
import ModelReport from "./pages/productReport/ModelReport";
import NewStaff from "./pages/newUser/NewStaff";
import CommissionList from "./pages/commissionList/CommissionList";
import SliderList from "./pages/sliderList/SliderList";
import TermsList from "./pages/termsList/TermsList";
import NewTerms from "./pages/newTerms/NewTerms";
import NewSlider from "./pages/newProduct/NewSlider";
import WarrantyRequestList from "./pages/warrantyList/WarrantyRequestList";
import ChangePassword from "./pages/changePassword/ChangePassword";

function App() {
    const admin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isAdmin : null
    );
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const salesperson = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "salesperson"
            : null
    );

    return (
        <div className="globalContainer">
            <Router>
                <Switch>
                    <Route exact path="/">
                        {admin ||
                        superadmin ||
                        staff ||
                        manager ||
                        accountant ||
                        outright ||
                        salesperson ? (
                            <>
                                {/* <Topbar /> */}
                                <div className="container">
                                    <Sidebar />
                                    <ModernPageWrapper title="Orders" subtitle="Manage and track all your solar installation orders">
                                        <OrderList />
                                    </ModernPageWrapper>
                                </div>
                            </>
                        ) : (
                            <Login />
                        )}
                    </Route>
                    {(staff ||
                        manager ||
                        admin ||
                        superadmin ||
                        accountant ||
                        outright ||
                        salesperson) && (
                        <>
                            {/* <Topbar /> */}
                            <div className="container">
                                <Sidebar />
                                <div className="mainContent">
                                    <Route path="/orders">
                                        <ModernPageWrapper title="Orders" subtitle="Manage and track all your solar installation orders">
                                            <OrderList />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/statements">
                                        <ModernPageWrapper title="Statements" subtitle="View customer financial statements">
                                            <StatementList />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/tradeinlist">
                                        <ModernPageWrapper title="Trade-in List" subtitle="Manage equipment trade-in transactions">
                                            <TradeInList />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/supplierlist">
                                        <ModernPageWrapper title="Supplier List" subtitle="Manage solar equipment suppliers">
                                            <SupplierList />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/expenseslist">
                                        <ModernPageWrapper title="Expenses List" subtitle="Track installation and operational expenses">
                                            <JournalList />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/completedeposit">
                                        <ModernPageWrapper title="Complete Deposits" subtitle="View completed deposit transactions">
                                            <CompleteDepositList />
                                        </ModernPageWrapper>
                                    </Route>
                                    {!salesperson && (
                                        <Route path="/history">
                                            <ModernPageWrapper title="Customer History" subtitle="View customer solar installation history">
                                                <History />
                                            </ModernPageWrapper>
                                        </Route>
                                    )}
                                    <Route path="/installments">
                                        <ModernPageWrapper title="Installments" subtitle="Manage payment installments">
                                            <DepositHistory />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/journals">
                                        <ModernPageWrapper title="Journals" subtitle="View financial journal entries">
                                            <Journals />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/deposits">
                                        <ModernPageWrapper title="Deposits" subtitle="Manage customer deposits">
                                            <DepositList />
                                        </ModernPageWrapper>
                                    </Route>
                                    <Route path="/completeorder">
                                        <ModernPageWrapper title="Complete Orders" subtitle="View completed solar installation orders">
                                            <EcommerceList />
                                        </ModernPageWrapper>
                                    </Route>
                                {(staff ||
                                    manager ||
                                    admin ||
                                    superadmin ||
                                    outright ||
                                    salesperson) && (
                                    <>
                                        <Route exact path="/pos">
                                            <ModernPageWrapper
                                                title="Point of Sale"
                                                subtitle="Process solar equipment sales"
                                                disableMobileCenter
                                            >
                                                <Pos />
                                            </ModernPageWrapper>
                                        </Route>
                                        {(staff ||
                                            manager ||
                                            admin ||
                                            superadmin ||
                                            outright) && (
                                        <>
                                        <Route exact path="/tradein">
                                            <ModernPageWrapper title="Trade-in" subtitle="Process equipment trade-in transactions">
                                                <TradeIn />
                                            </ModernPageWrapper>
                                        </Route>
                                        <Route exact path="/operatingexpenses">
                                            <ModernPageWrapper title="Operating Expenses" subtitle="Manage installation and operational expenses">
                                                <Journal />
                                            </ModernPageWrapper>
                                        </Route>
                                        <Route exact path="/assets">
                                            <ModernPageWrapper title="Assets" subtitle="Manage company assets and equipment">
                                                <Assets />
                                            </ModernPageWrapper>
                                        </Route>
                                        <Route exact path="/supplier">
                                            <ModernPageWrapper title="Supplier" subtitle="Manage solar equipment suppliers">
                                                <Supplier />
                                            </ModernPageWrapper>
                                        </Route>
                                        <Route path="/newsupplier">
                                            <ModernPageWrapper title="New Supplier" subtitle="Add new solar equipment supplier">
                                                <NewSupplier />
                                            </ModernPageWrapper>
                                        </Route>
                                        <Route path="/deliveryorders">
                                            <ModernPageWrapper title="Delivery Orders" subtitle="Manage equipment delivery orders">
                                                <DeliveryOrder />
                                            </ModernPageWrapper>
                                        </Route>
                                        </>
                                        )}
                                        <Route exact path="/newuser">
                                            <ModernPageWrapper title="New User" subtitle="Create new customer account">
                                                <NewUser />
                                            </ModernPageWrapper>
                                        </Route>
                                        {(manager ||
                                            admin ||
                                            superadmin ||
                                            outright) && (
                                            <>
                                                <Route path="/warranties">
                                                    <ModernPageWrapper title="Warranties" subtitle="Manage solar equipment warranties">
                                                        <WarrantyList />
                                                    </ModernPageWrapper>
                                                </Route>
                                                <Route path="/returns">
                                                    <ModernPageWrapper title="Returns" subtitle="Manage equipment returns">
                                                        <ReturnList />
                                                    </ModernPageWrapper>
                                                </Route>
                                                <Route path="/stocks">
                                                    <ModernPageWrapper title="Stock Inventory" subtitle="Manage solar equipment inventory">
                                                        <StockList />
                                                    </ModernPageWrapper>
                                                </Route>
                                                <Route path="/checklist">
                                                    <ModernPageWrapper title="Installation Checklist" subtitle="Manage installation checklists">
                                                        <Checklist />
                                                    </ModernPageWrapper>
                                                </Route>
                                                <Route path="/transfer">
                                                    <ModernPageWrapper title="Equipment Transfer" subtitle="Manage equipment transfers">
                                                        <Transfer />
                                                    </ModernPageWrapper>
                                                </Route>
                                                <Route path="/commissions">
                                                    <ModernPageWrapper title="Commission Management" subtitle="Manage sales commissions">
                                                        <CommissionList />
                                                    </ModernPageWrapper>
                                                </Route>
                                                {admin && (
                                                    <>
                                                        <Route path="/products">
                                                            <ModernPageWrapper title="Solar Products" subtitle="Manage solar equipment catalog">
                                                                <ProductList />
                                                            </ModernPageWrapper>
                                                        </Route>
                                                        <Route path="/newproduct">
                                                            <ModernPageWrapper title="New Product" subtitle="Add new solar equipment">
                                                                <NewProduct />
                                                            </ModernPageWrapper>
                                                        </Route>

                                                        <Route path="/newslider">
                                                            <ModernPageWrapper title="New Slider" subtitle="Create new promotional slider">
                                                                <NewSlider />
                                                            </ModernPageWrapper>
                                                        </Route>

                                                        <Route path="/affiliates">
                                                            <ModernPageWrapper title="Affiliate Partners" subtitle="Manage solar installer affiliates">
                                                                <AffiliateList />
                                                            </ModernPageWrapper>
                                                        </Route>

                                                        {superadmin && (
                                                            <>
                                                                <Route path="/outlets">
                                                                    <ModernPageWrapper title="Outlet Management" subtitle="Manage solar installation outlets">
                                                                        <Outlet />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newwarranty">
                                                                    <ModernPageWrapper title="New Warranty" subtitle="Create new equipment warranty">
                                                                        <NewWarranty />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/transactions">
                                                                    <ModernPageWrapper title="Transaction History" subtitle="View all system transactions">
                                                                        <TransactionList />
                                                                    </ModernPageWrapper>
                                                                </Route>

                                                                <Route path="/newadmin">
                                                                    <ModernPageWrapper title="New Admin" subtitle="Create new admin account">
                                                                        <NewAdmin />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newbrand">
                                                                    <ModernPageWrapper title="New Brand" subtitle="Add new solar equipment brand">
                                                                        <NewBrand />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newvehicle">
                                                                    <ModernPageWrapper title="New Vehicle" subtitle="Add new installation vehicle">
                                                                        <NewVehicle />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newcategory">
                                                                    <ModernPageWrapper title="New Category" subtitle="Add new product category">
                                                                        <NewCategory />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/sliders">
                                                                    <ModernPageWrapper title="Website Sliders" subtitle="Manage promotional sliders">
                                                                        <SliderList />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/warrantyrequests">
                                                                    <ModernPageWrapper title="Warranty Requests" subtitle="Manage warranty claims">
                                                                        <WarrantyRequestList />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/brands">
                                                                    <ModernPageWrapper title="Equipment Brands" subtitle="Manage solar equipment brands">
                                                                        <Brand />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/vehicles">
                                                                    <ModernPageWrapper title="Fleet Management" subtitle="Manage installation vehicles">
                                                                        <VehicleList />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/categories">
                                                                    <ModernPageWrapper title="Product Categories" subtitle="Manage equipment categories">
                                                                        <Category />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/campaigns">
                                                                    <ModernPageWrapper title="Marketing Campaigns" subtitle="Manage promotional campaigns">
                                                                        <Campaign />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route exact path="/terms">
                                                                    <ModernPageWrapper title="Terms" subtitle="Manage terms and subscription plans">
                                                                        <TermsList />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newterms">
                                                                    <ModernPageWrapper title="New Terms" subtitle="Create new terms record">
                                                                        <NewTerms />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/terms/:id">
                                                                    <ModernPageWrapper title="Edit Terms" subtitle="Edit terms record">
                                                                        <NewTerms />
                                                                    </ModernPageWrapper>
                                                                </Route>

                                                                <Route path="/productgallery/:productId">
                                                                    <ModernPageWrapper title="Product Gallery" subtitle="Manage product images">
                                                                        <ProductGallery />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/productstatus/:productId">
                                                                    <ModernPageWrapper title="Product Status" subtitle="Manage product availability">
                                                                        <ProductStatus />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/product/:productId">
                                                                    <ModernPageWrapper title="Product Details" subtitle="View product information">
                                                                        <Product />
                                                                    </ModernPageWrapper>
                                                                </Route>

                                                  
                                                                <Route path="/deliveryorderupload/:deliveryOrderId">
                                                                    <ModernPageWrapper title="Delivery Order Upload" subtitle="Upload delivery documents">
                                                                        <DeliveryOrderUpload />
                                                                    </ModernPageWrapper>
                                                                </Route>

                                                                <Route path="/productreport">
                                                                    <ModernPageWrapper title="Product Reports" subtitle="View product analytics">
                                                                        <ProductReport />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/modelreport">
                                                                    <ModernPageWrapper title="Model Reports" subtitle="View model analytics">
                                                                        <ModelReport />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/productcolor/:productId">
                                                                    <ModernPageWrapper title="Product Colors" subtitle="Manage product variations">
                                                                        <ProductColor />
                                                                    </ModernPageWrapper>
                                                                </Route>

                                                                <Route path="/affiliatereport">
                                                                    <ModernPageWrapper title="Affiliate Reports" subtitle="View affiliate analytics">
                                                                        <AffiliateReport />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                            </>
                                                        )}

                                                        {(superadmin ||
                                                            outright) && (
                                                            <>
                                                                <Route path="/salesreport">
                                                                    <ModernPageWrapper title="Sales Reports" subtitle="View sales analytics">
                                                                        <SalesReport />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newstaff">
                                                                    <ModernPageWrapper title="New Staff" subtitle="Add new staff member">
                                                                        <NewStaff />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                            </>
                                                        )}

                                                        {superadmin && (
                                                            <>
                                                                <Route path="/report">
                                                                    <ModernPageWrapper title="System Reports" subtitle="View comprehensive reports">
                                                                        <Report />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                                <Route path="/newaffiliate">
                                                                    <ModernPageWrapper title="New Affiliate" subtitle="Add new affiliate partner">
                                                                        <NewAffiliate />
                                                                    </ModernPageWrapper>
                                                                </Route>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                                    {(superadmin ||
                                        outright ||
                                        salesperson) && (
                                        <>
                                            <Route path="/users">
                                                <ModernPageWrapper title="User Management" subtitle="Manage system users">
                                                    <User />
                                                </ModernPageWrapper>
                                            </Route>
                                            <Route path="/order/:productId">
                                                <ModernPageWrapper title="Edit Order" subtitle="Modify order details">
                                                    <EditOrder />
                                                </ModernPageWrapper>
                                            </Route>
                                        </>
                                    )}
                                    <Route path="/changepassword">
                                        <ModernPageWrapper title="Change Password" subtitle="Update your account password">
                                            <ChangePassword />
                                        </ModernPageWrapper>
                                    </Route>
                                </div>
                            </div>
                        </>
                    )}
                </Switch>
            </Router>
        </div>
    );
}

export default App;
